// removed by extract-text-webpack-plugin
module.exports = {"root":"StoryHeader__root--1qbLT","icon":"StoryHeader__icon--QKyJm","profile":"StoryHeader__profile--2m8a_","bylinePhoto":"StoryHeader__bylinePhoto--1gS0W StoryHeader__icon--QKyJm","author":"StoryHeader__author--3R4v5","date":"StoryHeader__date--1ij89","bounce":"StoryHeader__bounce--3lKol"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/StoryHeader/StoryHeader.css
// module id = ./src/components/Library/StoryHeader/StoryHeader.css
// module chunks = 1